module.exports = __webpack_public_path__ + "img/02_tone_1210.c79d43b2.png";